import { createFileRoute } from '@tanstack/react-router';
import { DEFAULT_AUTHENTICATED_ROUTE } from '../util/routing/defaults';
import type { RouteGuardOptions } from '../util/routing/guard';

export const Route = createFileRoute('/_auth')({
  staticData: {
    guard: { auth: { requireAuthenticated: false, redirectToIfNotMet: DEFAULT_AUTHENTICATED_ROUTE } },
  } as const satisfies RouteGuardOptions,
});
